import { DEPARTMENTS, INGREDIENT_CATEGORIES } from '@fewerbags/schema';
import type { Department, IngredientCategory, StoreDto } from '@fewerbags/schema';

export const DEPARTMENT_LABEL: Record<Department, string> = {
  produce: 'Produce',
  deli: 'Deli',
  bakery: 'Bakery',
  butcher: 'Butcher',
  seafood: 'Seafood',
  aisles: 'Aisles',
  dairy: 'Dairy',
  frozen: 'Frozen',
  other: 'Other',
};

export const CATEGORY_LABEL: Record<IngredientCategory, string> = {
  produce: 'Produce',
  meat: 'Meat',
  seafood: 'Seafood',
  dairy: 'Dairy',
  bakery: 'Bakery',
  pantry: 'Pantry',
  frozen: 'Frozen',
  spices: 'Spices',
  beverages: 'Beverages',
  other: 'Other',
};

export const CATEGORY_OPTIONS = INGREDIENT_CATEGORIES.map((c) => ({
  value: c,
  label: CATEGORY_LABEL[c],
}));

export { DEPARTMENTS };

/** "−2 days", "+10%", "−2 days, +10%" — null when the store has no whole-store rule. */
export function shelfLifeBadgeText(
  store: Pick<StoreDto, 'shelfLifeAdjustDays' | 'shelfLifeAdjustPct'>,
): string | null {
  const parts: string[] = [];
  if (store.shelfLifeAdjustDays) {
    parts.push(`${store.shelfLifeAdjustDays > 0 ? '+' : ''}${store.shelfLifeAdjustDays} days`);
  }
  if (store.shelfLifeAdjustPct) {
    parts.push(`${store.shelfLifeAdjustPct > 0 ? '+' : ''}${store.shelfLifeAdjustPct}%`);
  }
  return parts.length ? parts.join(', ') : null;
}

/** First few departments in walking order, for the store list summary. */
export function departmentOrderSummary(order: readonly Department[], max = 4): string {
  const shown = order.slice(0, max).map((d) => DEPARTMENT_LABEL[d]);
  return order.length > max ? `${shown.join(' → ')} → …` : shown.join(' → ');
}
